import React from 'react';
import type { FC } from 'react';

import { Button, ButtonType } from '@/common/button';
import { FloatingPanel, FloatingPanelItem, FloatingPanelType } from '@/common/floating-panel';
import { useTemplateEditorStore } from '../store';
import { FieldCard } from './field-card';

export interface ImageLayerLinkViewProps {
    onClose: () => void;
    onCreateField: () => void;
}

export const ImageLayerLinkView: FC<ImageLayerLinkViewProps> = ({ onClose, onCreateField }) => {
    const width = useTemplateEditorStore((s) => s.fieldsPanelWidth);

    return (
        <FloatingPanel
            className="pr-4 py-4 h-full flex-shrink-0 overflow-y-auto"
            type={FloatingPanelType.LIGHT}
            width={width}
        >
            <FloatingPanelItem className="flex flex-row justify-between items-center px-4">
                <p className="text-sm text-white font-medium">Link with Image Field</p>
                <button
                    title="Done"
                    className="text-white text-xs font-normal h-5"
                    type="button"
                    onClick={() => {
                        onClose();
                    }}
                >
                    Done
                </button>
            </FloatingPanelItem>

            <FloatingPanelItem className="h-full px-4">
                <div className="flex flex-col gap-3">
                    <div>
                        <Button
                            title="Create New Image Field"
                            className="w-full"
                            buttonType={ButtonType.PRIMARY}
                            onClick={() => onCreateField()}
                        />
                    </div>
                    <hr className="bg-gray-100 border-gray-100 w-full" />
                    <p className="text-sm text-white font-semibold">Image Fields</p>
                    <FieldCard showMenu={true} showLinkButton={true} isImage={true} />
                    <FieldCard showMenu={true} showLinkButton={true} isImage={true} />
                    <FieldCard showMenu={true} showLinkButton={true} isImage={true} />
                </div>
            </FloatingPanelItem>
        </FloatingPanel>
    );
};
